/*!
 * Copyright (c) 2017-2018 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _regeneratorRuntime = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/inherits");

var forge = require('node-forge');

var LinkedDataSignature2015 = require('./LinkedDataSignature2015');

module.exports =
/*#__PURE__*/
function (_LinkedDataSignature) {
  _inherits(EcdsaKoblitzSignature2016, _LinkedDataSignature);

  function EcdsaKoblitzSignature2016() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        privateKeyWif = _ref.privateKeyWif,
        publicKeyWif = _ref.publicKeyWif,
        creator = _ref.creator,
        date = _ref.date,
        domain = _ref.domain,
        nonce = _ref.nonce,
        useNativeCanonize = _ref.useNativeCanonize;

    _classCallCheck(this, EcdsaKoblitzSignature2016);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EcdsaKoblitzSignature2016).call(this, {
      type: 'EcdsaKoblitzSignature2016',
      creator: creator,
      date: date,
      domain: domain,
      nonce: nonce,
      useNativeCanonize: useNativeCanonize
    }));
    _this.privateKeyWif = privateKeyWif;
    _this.publicKeyWif = publicKeyWif;
    return _this;
  }

  _createClass(EcdsaKoblitzSignature2016, [{
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(_ref2) {
        var verifyData, proof, bitcoreMessage, bitcore, privateKey, message;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verifyData = _ref2.verifyData, proof = _ref2.proof;

                if (!(typeof this.privateKeyWif !== 'string')) {
                  _context.next = 3;
                  break;
                }

                throw new TypeError('"privateKeyWif" must be a base58 formatted string.');

              case 3:
                bitcoreMessage = require('bitcore-message');
                bitcore = bitcoreMessage.Bitcore;
                privateKey = bitcore.PrivateKey.fromWIF(this.privateKeyWif);
                message = bitcoreMessage(forge.util.binary.raw.encode(verifyData));
                proof.signatureValue = message.sign(privateKey);
                return _context.abrupt("return", proof);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sign(_x) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "verifySignature",
    value: function () {
      var _verifySignature = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(_ref3) {
        var verifyData, proof, bitcoreMessage, message;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                verifyData = _ref3.verifyData, proof = _ref3.proof;
                bitcoreMessage = require('bitcore-message');
                message = bitcoreMessage(forge.util.binary.raw.encode(verifyData));
                return _context2.abrupt("return", message.verify(this.publicKeyWif, proof.signatureValue));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function verifySignature(_x2) {
        return _verifySignature.apply(this, arguments);
      }

      return verifySignature;
    }()
  }, {
    key: "getVerificationMethod",
    value: function () {
      var _getVerificationMethod = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(_ref4) {
        var proof, documentLoader, verificationMethod;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                proof = _ref4.proof, documentLoader = _ref4.documentLoader;
                _context3.next = 3;
                return _get(_getPrototypeOf(EcdsaKoblitzSignature2016.prototype), "getVerificationMethod", this).call(this, {
                  proof: proof,
                  documentLoader: documentLoader
                });

              case 3:
                verificationMethod = _context3.sent;

                if (!(typeof verificationMethod.publicKeyWif !== 'string')) {
                  _context3.next = 6;
                  break;
                }

                throw new TypeError('Unknown public key encoding. Public key encoding must be ' + '"publicKeyWif".');

              case 6:
                if (!this.publicKeyWif) {
                  this.publicKeyWif = verificationMethod.publicKeyWif;
                }

                return _context3.abrupt("return", verificationMethod);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getVerificationMethod(_x3) {
        return _getVerificationMethod.apply(this, arguments);
      }

      return getVerificationMethod;
    }()
  }]);

  return EcdsaKoblitzSignature2016;
}(LinkedDataSignature2015);